import { createFileRoute } from '@tanstack/react-router';
import { parseStockMatrixSearch, type StockMatrixSearch } from '@/features/stock/stock-search';
import { StockMatrixPage } from '@/features/stock/stock-matrix-page';

export const Route = createFileRoute('/_app/stock/')({
  // every filter, the selected item, the expanded row and the sort live in the
  // URL, so a matrix can be pasted to the other partner and a back from the item
  // card lands on the same table (§2.1)
  validateSearch: (s: Record<string, unknown>): StockMatrixSearch => parseStockMatrixSearch(s),
  component: function Stock() {
    return <StockMatrixPage search={Route.useSearch()} />;
  },
});
